<template>
  <div>
    <router-view></router-view>
    <check></check>
  </div>
</template>

<script>
import Check from '../components/Check.vue'
export default {
  components: {
    Check
  }
}
</script>

<style>

</style>



/** WEBPACK FOOTER **
 ** App.vue?1daaed41
 **/